import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import Sidebar from './Sidebar'
import Videos from './Videos'
import { fatchFromApi } from '../utils/fatchFromApi'

const Feed = () => {
  const [selectedCategory, setSelectedCategory] = React.useState('New');

  const [videos, setVideos] = React.useState([]);

  console.log(videos);

  React.useEffect(() => {
    fatchFromApi(`search?part=snippet&q=${selectedCategory}`).then((data) => setVideos(data.items))
  },[selectedCategory])

  // axios.request(options).then(function (response) {
  //   console.log(response.data);
  // }).catch(function (error) {
  //   console.error(error);
  // });

  return (
    <Stack sx={{flexDirection: {sx: 'column', md: 'row'}}}>

      <Box sx={{height: {sx: 'auto', md: '92vh'}, borderRight: '1px solid #3d3d3d', px: {sx: 0, md: 2}}}>

          <Sidebar selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory} />

        <Typography className='copyright' variant='body2' sx={{mt: 1.5, color:'#fff'}}>
          Copyright 2022 AR Media
        </Typography>

      </Box>

      <Box p={2} sx={{overflowY: 'auto', height: '90vh', flex: 2}}>
        
        <Typography variant='h4' fontWeight='bold' mb={2} sx={{color: 'white'}}>
          {selectedCategory} <span style={{color:'#f31503'}}>Videos</span>
        </Typography>
        
        <Videos videos={videos} />
  
      </Box>
    </Stack>
  )
}

export default Feed